import { FunctionComponent, useRef } from "react";

import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { TooltipWrapper } from "../../Components/TooltipWrapper/TooltipWrapper";

import "./ActionButton.scss";

interface IActionButtonProps {
  id: string;
  label?: string;
  icon?: IconProp;
  tooltip?: string;
  tooltipPosition?: "top" | "bottom" | "left" | "right" | "mouse";
  tooltipDisabled?: boolean;
  buttonDisabled?: boolean;
  hideBackground?: boolean;
  removeSpaces?: boolean;
  hide?: boolean;
  active?: boolean;
  centeredHorizontally?: boolean;
  fullWidth?: boolean;
  customClasses?: string;
  onClick?: (event: any) => void;
}

export const ActionButton: FunctionComponent<IActionButtonProps> = (props: IActionButtonProps) => {
  const tooltipRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={tooltipRef} className={classNames(props.customClasses, "action-button-wrapper")}>
      {/* TooltipWrapper is used instead of Button.tooltip because native button tooltips do not show on disabled buttons */}
      <TooltipWrapper
        targetRef={tooltipRef}
        content={props.tooltip ?? ""}
        position={props.tooltipPosition ?? "right"}
        disabled={props.tooltipDisabled || props.hide}
      />

      <Button
        type="button"
        className={classNames(
          "action-button",
          {
            active: props.active,
            "icon-only": !props.label && props.icon,
            "text-only": props.label && !props.icon,
            "hide-background": props.hideBackground,
            "remove-spaces": props.removeSpaces,
            hide: props.hide,
            disabled: props.buttonDisabled,
            "center-horizontally": props.centeredHorizontally,
            "full-width": props.fullWidth,
          },
          props.customClasses || "",
        )}
        onClick={!props.buttonDisabled ? props.onClick : undefined}
        onKeyDown={event => !props.buttonDisabled && event.key === "Enter" && props.onClick?.(event)}
        disabled={props.buttonDisabled}
        id={props.id}
        data-testid={props.id}
        icon={props.icon ? <FontAwesomeIcon icon={props.icon} /> : undefined}
        label={props.label || undefined}
      />
    </div>
  );
};
